
<div class="flex flex-col w-full h-full">
  <p *ngIf="(visibleCard | visibleCardCount : disableCardSnapshot) === 0" class="pt-12 text-center empty-state-text text-secondary">Add your favorite cards to the Dashboard using the <b>'Customize Cards'</b> filter above.</p>
  <div class="reporting-dashboard pb-4 pt-2" *ngIf="cardOrder" [ngClass]="{'single-card': (visibleCard | visibleCardCount : disableCardSnapshot) === 1}">
    <ng-container *ngFor="let card of cardOrder">
        <ng-container [ngSwitch]="card">
            <ng-container *ngSwitchCase="dashboardCards.EXPORTS">
                <div class="stacked"
                    *ngIf="(visibleCard[dashboardCards.EXPORTS]) || (isEnrichmentEnabled && visibleCard[dashboardCards.ENRICHMENT])"
                    [@fadeOutScale]>
                    <div class="card-item" *ngIf="visibleCard[dashboardCards.EXPORTS]" [@fadeOutScale]>
                        <app-exports-card [isLoading]="isExportsSummaryLoading$ | async"
                            [exportsData]="exportsSummary$ | async"
                            [useLargeText]="!isEnrichmentEnabled || !visibleCard[dashboardCards.ENRICHMENT]"
                            (sendEvent)="onDropdownValueSelect($event)" class="w-full h-full">
                        </app-exports-card>
                    </div>
    
                    <!-- disable condtion -->
                    <div class="card-item" *ngIf="isEnrichmentEnabled && visibleCard[dashboardCards.ENRICHMENT]"
                        [@fadeOutScale]>
                        <app-enrichment-card [isLoading]="isEnrichmentSummaryLoading$ | async"
                            [enrichmentData]="enrichmentSummary$ | async"
                            [useLargeText]="!visibleCard[dashboardCards.EXPORTS]" class="w-full h-full">
                        </app-enrichment-card>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="dashboardCards.VISITOR_INTEL">
                <div class="card-item"
                    *ngIf="([addonsIdentifiersEnum.VISITORINTEL] | hasPlans | async) && visibleCard[dashboardCards.VISITOR_INTEL]"
                    [@fadeOutScale]>
                    <app-visitor-intel-card
                        [isLoading]="(isVisitorIntelSummaryLoading$ | async) || (isVisitorIntelDataLoading$ | async) || (isVisitorIntelAgentDataLoading$ | async) || (isRunVisitorIntelAutomationLoading$ | async) || (isVisitorIntelWeeklyExportedCountLoading$ | async) || (isVisitorIntelAllWeeklyVisitedExportedCountLoading$ | async)"
                        [visitorIntelData]="visitorIntelSummary$ | async" [isAdmin]="isAdmin$ | async"
                        [visitorIntelAgents]="(isVisitorIntelSetupDone$ | async) ? (visitorIntelAgents$ | async) : null"
                        [isVisitorIntelSetupDone]="isVisitorIntelSetupDone$ | async"
                        [chartData]="(weeklyAgentData$ | async)?.chartData"
                        [chartDataLabels]="(weeklyAgentData$ | async)?.chartDataLabels"
                        [isWeeklyAgentsNotRun]="(weeklyAgentData$ | async)?.isWeeklyAgentsNotRun"
                        [tableData]="(weeklyAgentData$ | async)?.tableData"
                        [viewAllData]="(weeklyAgentData$ | async)?.viewAllData"
                        [visitorIntelAllWeeklyExportedData]="allVisitorIntelWeeklyExportedData$ | async"
                        [isAllAgentsEmailOnly]="isAllAgentsEmailOnly" [isAllAgentsExportOnly]="isAllAgentsExportOnly"
                        (searchTrigger)="onSearch($event)" (runVIAgent)="runVIAutomation($event)"
                        (agentSelectionChanged)="updateAgent($event)" (saveSearchTrigger)="onSaveSearch($event)"
                        class="w-full h-full">
                    </app-visitor-intel-card>
                </div>
            </ng-container>
    
            <ng-container *ngSwitchCase="dashboardCards.INTENT">
                <div class="card-item"
                    *ngIf="([addonsIdentifiersEnum.SALESINTELINTENT, addonsIdentifiersEnum.INTENT] | hasPlans | async) && visibleCard[dashboardCards.INTENT]"
                    [@fadeOutScale]>
                    <app-intent-card class="w-full h-full" (saveSearchTrigger)="onSaveSearch($event)"
                        (searchTrigger)="onSearch($event)">
                    </app-intent-card>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="dashboardCards.GROWTH_SIGNALS">
                <div class="card-item"
                    *ngIf="showGrowthSignalsCard && visibleCard[dashboardCards.GROWTH_SIGNALS]"
                    [@fadeOutScale]>
                    <app-growth-signals-card-container class="w-full h-full" (saveSearchTrigger)="onSaveSearch($event)"
                        (searchTrigger)="onSearch($event)">
                    </app-growth-signals-card-container>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="dashboardCards.NEW_TECHNOLOGY">
                <div class="card-item"
                    *ngIf="showTechChangeCard && visibleCard[dashboardCards.NEW_TECHNOLOGY]"
                    [@fadeOutScale]>
                    <app-tech-change-card-container class="w-full h-full">
                    </app-tech-change-card-container>
                </div>
            </ng-container>
    
            <ng-container *ngSwitchCase="dashboardCards.ROD">
                <div class="card-item" *ngIf="visibleCard[dashboardCards.ROD]"
                    [@fadeOutScale]>
                    <app-rod-card [isLoading]="isRodWeeklySummaryLoading$ | async" [rodData]="rodWeeklySummary$ | async"
                        (userScopeChange)="loadRODWeeklySummary($event)"
                        class="w-full h-full">
                    </app-rod-card>
                </div>
            </ng-container>
    
            <ng-container *ngSwitchCase="dashboardCards.NEWS">
                <div class="card-item"
                    *ngIf="visibleCard[dashboardCards.NEWS] && showNewsCard"
                    [@fadeOutScale]>
                    <app-news-card
                        [isLoading]="(isNewsAlertsDataLoading$ | async) || (isNewsAutomationsWeeklyArticlesCountLoading$ | async)"
                        [newsAutomationsAgents]="(allNewsAutomationsWeeklyData$ | async)?.agents"
                        [allNewsData]="(allNewsAutomationsWeeklyData$ | async)?.articles"
                        [selectedNewsData]="selectedNewsAutomationsWeeklyData$ | async"
                        (agentSelectionChanged)="updateNewsArticleAgent($event)"
                        [chartData]="(newsArticlesWeeklyAgentData$ | async)?.chartData"
                        [chartDataLabels]="(newsArticlesWeeklyAgentData$ | async)?.chartDataLabels"
                        [newsAutomationData]="(newsArticlesWeeklyAgentData$ | async)?.newsAutomationData"
                        (userScopeChange)="loadNewsArticlesWeeklySummary($event)"
                        class="w-full h-full">
                    </app-news-card>
                </div>
            </ng-container>
    
            <ng-container *ngSwitchCase="dashboardCards.INTEGRATIONS">
                <div class="flex flex-col card-item"
                    *ngIf="showIntegrationsCard && visibleCard[dashboardCards.INTEGRATIONS]"
                    [@fadeOutScale]>
                    <app-integration-card class="w-full h-full"></app-integration-card>
                </div>
            </ng-container>
    
            <ng-container *ngSwitchCase="dashboardCards.REV_DRIVER">
                <div class="card-item"
                    *ngIf="showRevDriverCard && visibleCard[dashboardCards.REV_DRIVER]"
                    [@fadeOutScale]>
                    <app-rev-driver-card class="w-full h-full"></app-rev-driver-card>
                </div>
            </ng-container>
    
            <ng-container *ngSwitchCase="dashboardCards.RECOMMENDED_LISTS">
                <div class="card-item"
                    *ngIf="visibleCard[dashboardCards.RECOMMENDED_LISTS]"
                    [@fadeOutScale]>
                    <app-recommended-lists-card class="w-full h-full"></app-recommended-lists-card>
                </div>
            </ng-container>
    
            <ng-container *ngSwitchCase="dashboardCards.SAVED_SEARCHES">
                <div class="card-item"
                    *ngIf="visibleCard[dashboardCards.SAVED_SEARCHES]"
                    [@fadeOutScale]>
                    <app-saved-searches-card-container class="w-full h-full"></app-saved-searches-card-container>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="dashboardCards.SESSIONS">
                <div class="card-item"
                    *ngIf="visibleCard[dashboardCards.SESSIONS]"
                    [@fadeOutScale]>
                    <app-sessions-card-container class="w-full h-full"></app-sessions-card-container>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="dashboardCards.SEARCHES">
                <div class="card-item"
                    *ngIf="visibleCard[dashboardCards.SEARCHES]"
                    [@fadeOutScale]>
                    <app-searches-card-container class="w-full h-full"></app-searches-card-container>
                </div>
            </ng-container>
            
            <ng-container *ngSwitchCase="dashboardCards.ICP">
                <div class="card-item"
                    *ngIf="showICPCard && visibleCard[dashboardCards.ICP]"
                    [@fadeOutScale]>
                    <app-icp-card-container class="w-full h-full" (saveSearchTrigger)="onSaveSearch($event)"></app-icp-card-container>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
  </div>
</div>
